import { Spinner } from "@shadcn/components/ui/spinner"
import "./LoaderButton.css"

export function LoadingSpinner({
	isLoading,
	style = undefined,
	className = undefined,
}: React.HTMLAttributes<HTMLDivElement> & { isLoading: boolean }) {
	return isLoading ? (
		<Spinner data-testid="loading-spinner" style={style} className={`size-4 ${className ?? ""}`} />
	) : (
		<div></div>
	)
}

export const LoaderFallback = () => {
	return (
		<div className="loader-fallback">
			<div>
				<LoadingSpinner isLoading={true} className="inline" />
				<h5 className="bs-h5">Loading...</h5>
			</div>
		</div>
	)
}
